module.exports = __webpack_public_path__ + "img/bg3.4ee002a6.png";